import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { MatDialog } from '@angular/material/dialog';
import { AuthDialogComponent } from './auth-dialog/auth-dialog.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(
    private authService: AuthService, 
    private router: Router,
    private dialog: MatDialog
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Don't open auth dialog if user is navigating to the landing page
    if (state.url === '/' || state.url === '') {
      return true;
    }
    
    let userType: any = route.url[0].path
    let result: any = await this.authService.isAuthenticated(userType)
    if(result){
      console.log("User Type:", result);
      
      // Start user activity monitoring when authentication is successful
      this.authService.startUserActivityMonitoring();
      
      switch(userType){
        case "marketplace":
          if(result == "marketplace")
            return true
          else{
            this.router.navigate(['brand'])
            return false
          }
        case "brand":
          if(result == "brand")
            return true
          else{
            this.router.navigate(['marketplace'])
            return false
          }
      }
    }
    if (result) {
      return true;
    } else {
      // Instead of opening dialog, redirect to landing page where auth forms are embedded
      this.router.navigate(['']);
      return false;
    }
  }
}
